import React, { FC } from 'react';

import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Form, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { PartySearch } from '@components/daData';

import { LAYOUT, TAIL_LAYOUT } from '../../constants';
import { IStep5 } from '../../interfaces';

import { ValidationSchema } from './data/validation';

interface IProps {
  initialValues: IStep5;
  innError?: string;
  onNext: (values: IStep5) => void;
  onPrev: () => void;
}

export const Step5: FC<IProps> = (props) => {
  const [form] = Form.useForm();
  const registrationT = useTranslation(NSKeys.registration);
  const validationT = useTranslation(NSKeys.validation);
  const company_name = Form.useWatch('company_name', form);

  React.useEffect(() => {
    if (props.innError) {
      form.setFields([{ name: 'inn', errors: [props.innError] }]);
    }
  }, [props.innError]);

  const yupSync = {
    async validator({ field }: any, value: any) {
      await ValidationSchema(validationT.t).validateSyncAt(field, { [field]: value });
    },
  };

  return (
    <Form
      form={form}
      name="login_form_step1"
      initialValues={props.initialValues}
      onFinish={props.onNext}
      size="large"
      {...LAYOUT}>
      <Form.Item required label={registrationT.t('form.company')} name="company_name" rules={[yupSync]}>
        <Input placeholder={registrationT.t('form.companyPlaceholder')} />
      </Form.Item>

      <Form.Item required label={registrationT.t('form.inn')} name="inn" rules={[yupSync]}>
        <PartySearch />
      </Form.Item>

      <Form.Item {...TAIL_LAYOUT}>
        <Row justify="space-between">
          <Button icon={<ArrowLeftOutlined />} disabled={company_name === ''} onClick={props.onPrev}>
            {registrationT.t('btnBack')}
          </Button>
          <Button type="primary" htmlType="submit">
            {registrationT.t('btnNext')}
          </Button>
        </Row>
      </Form.Item>
    </Form>
  );
};
